import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-document",
  "use": "icon-document-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-document\"><path d=\"M529.664 213.341091H896A42.658909 42.658909 0 0 1 938.682182 256v597.341091A42.658909 42.658909 0 0 1 896 896h-768a42.658909 42.658909 0 0 1-42.658909-42.658909V170.658909A42.658909 42.658909 0 0 1 128 128h316.346182z\" fill=\"#FAFAFA\" p-id=\"2507\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol